import { Component, signal, computed } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  isMobileMenuOpen = signal(false);
  isProfileOpen = signal(false);
  mobileSubmenuOpen = signal<string | null>(null);

  activeLink =
    'text-cnfpc-primary-darker relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:bg-cnfpc-primary-darker';
  activeDropdown: string | null = null;

  // Expose signals for template binding
  account = computed(() => this.authService.currentUser());
  isAuthenticated = computed(() => this.authService.isAuthenticated());
  isProdEnvironment = computed(() => this.authService.isProdEnvironment());
  environmentLabel = computed(() => this.authService.getEnvironmentLabel());
  isAdmin = computed(() => this.authService.isAdmin());
  isAGest = computed(() => this.authService.hasGestRole());
  profilePhoto = computed(() => this.authService.userProfilePhoto()); // Add this line

  //TODO is there a possible scenario without being logged in?
  username = computed(() => this.account()?.name ?? 'Guest');

  constructor(private authService: AuthService) {
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen.update((state) => !state);
    if (!this.isMobileMenuOpen()) {
      this.mobileSubmenuOpen.set(null);
    }
  }

  toggleMobileSubmenu(menu: string) {
    this.mobileSubmenuOpen.set(this.mobileSubmenuOpen() === menu ? null : menu);
  }

  toggleProfileDropdown() {
    this.isProfileOpen.update((state) => !state);
  }

  login() {
    this.authService.login().subscribe();
  }

  logout() {
    this.authService.logout().subscribe();
  }
}
